export const THEME = {
  colors: {
    // Backgrounds
    bg:          '#080c18',   // Deep space black
    panel:       '#0d1526',   // Dark panel
    card:        '#0f1a2e',   // Card background
    cardHover:   '#142035',   // Card on hover

    // Arc reactor blue (primary accent)
    blue:        '#00d4ff',
    blueMid:     '#00a8cc',
    blueDim:     '#006b8a',
    blueDeep:    '#003a55',

    // Gold (XAU)
    gold:        '#ffd700',
    goldBright:  '#ffec6e',
    goldDim:     '#ccaa00',

    // Signal colors
    green:       '#00ff88',
    red:         '#ff3333',
    orange:      '#ff9900',
    orangeDim:   '#cc7700',

    // Text
    text:        '#e0f4ff',
    textDim:     '#7ab3cc',
    textMuted:   '#94a3b8',
    textFaint:   '#3a6a7a',

    // Borders
    border:      '#1a3a4a',
    borderGlow:  '#003a55',

    // Setup grade colors
    gradeAP:     '#00ff88',   // A+ green
    gradeA:      '#00d4ff',   // A  blue
    gradeB:      '#ffaa00',   // B  orange
    gradeC:      '#ff6600',   // C  dark orange
    gradeD:      '#ff3333',   // D  red

    // Glow overlays (use as background)
    glowBlue:    'rgba(0, 212, 255, 0.10)',
    glowGold:    'rgba(255, 215, 0, 0.10)',
    glowGreen:   'rgba(0, 255, 136, 0.10)',
    glowRed:     'rgba(255, 51, 51, 0.10)',
    glowOrange:  'rgba(255, 153, 0, 0.10)',
  },

  fonts: {
    hud:  "'Orbitron', monospace",
    body: "'Rajdhani', sans-serif",
    mono: "'Share Tech Mono', monospace",
  },

  // Reusable style objects
  card: {
    background: '#0f1a2e',
    border: '1px solid #1a3a4a',
    borderRadius: '8px',
    padding: '16px',
  },

  // Grade config — used throughout app
  grades: {
    'A+': { color: '#00ff88', bg: 'rgba(0,255,136,0.10)', label: 'ELITE',   min: 8.0 },
    'A':  { color: '#00d4ff', bg: 'rgba(0,212,255,0.10)', label: 'STRONG',  min: 6.5 },
    'B':  { color: '#ffaa00', bg: 'rgba(255,170,0,0.10)', label: 'DECENT',  min: 5.0 },
    'C':  { color: '#ff6600', bg: 'rgba(255,102,0,0.10)', label: 'WEAK',    min: 3.0 },
    'D':  { color: '#ff3333', bg: 'rgba(255,51,51,0.10)', label: 'SKIP',    min: 0.0 },
  },
};

// Helper — get grade config by score
export const getGradeByScore = (score) => {
  if (score >= 8.0) return { grade: 'A+', ...THEME.grades['A+'] };
  if (score >= 6.5) return { grade: 'A',  ...THEME.grades['A']  };
  if (score >= 5.0) return { grade: 'B',  ...THEME.grades['B']  };
  if (score >= 3.0) return { grade: 'C',  ...THEME.grades['C']  };
  return              { grade: 'D',  ...THEME.grades['D']  };
};

// Helper — get color for result
export const getResultColor = (result) => {
  const map = {
    WIN: '#00ff88', LOSS: '#ff3333',
    BE: '#ffaa00', PARTIAL: '#00d4ff', OPEN: '#7ab3cc'
  };
  return map[result] || '#7ab3cc';
};
